import { Spin } from 'antd';
import React from 'react';

export class Home extends React.Component {
  
  componentDidMount() {
    if (window.location.href.includes('staging')) {
      window.location.href = "https://staging.beautista.com";
    } else {
      window.location.href = "https://beautista.com";
    }
  }

  render() {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }
}
